var mapping_types_default = [
  {
    "RELEVANCE": "very high",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#closeMatch"
      }
    ],
    "definition": {
      "de": [
        "gleiche Bedeutung"
      ],
      "en": [
        "same meaning"
      ]
    },
    "notation": [
      "="
    ],
    "prefLabel": {
      "ar": "\u062A\u0637\u0627\u0628\u0642 \u062A\u0627\u0645",
      "be": "\u0434\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u0446\u044C",
      "be-tarask": "\u0434\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u044C\u0446\u044C",
      "bn": "\u09B9\u09C1\u09AC\u09C1\u09B9\u09C1 \u09AE\u09BF\u09B2",
      "bs": "ta\u010Dno podudaranje",
      "ca": "equival\xE8ncia exacta",
      "cs": "p\u0159esn\xE1 shoda",
      "da": "exact match",
      "de": "exakte \xDCbereinstimmung",
      "el": "\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 \u03B1\u03BD\u03C4\u03B9\u03C3\u03C4\u03BF\u03B9\u03C7\u03AF\u03B1",
      "en": "exact match",
      "eo": "ekzakta ekvivalento",
      "es": "equivalencia exacta",
      "et": "t\xE4pne vaste",
      "fi": "vastaava k\xE4site",
      "fr": "\xE9quivalence exacte",
      "ga": "meaitse\xE1il chruinn",
      "gl": "correspondencia exacta",
      "he": "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05DE\u05D3\u05D5\u05D9\u05E7\u05EA",
      "hu": "pontos egyez\xE9s",
      "id": "sama persis",
      "it": "corrispondenza esatta",
      "ja": "\u5B8C\u5168\u4E00\u81F4",
      "lv": "tie\u0161a sakrit\u012Bba",
      "mk": "\u0442\u043E\u0447\u043D\u043E \u0441\u043E\u0432\u043F\u0430\u0453\u0430\u045A\u0435",
      "ms": "padanan tepat",
      "ms-arab": "\u06A4\u0627\u062F\u0646\u0646 \u062A\u06A4\u062A",
      "nb": "eksakt samsvar",
      "nl": "exacte match",
      "nn": "eksakt samsvar",
      "pl": "dok\u0142adne dopasowanie",
      "pt": "correspond\xEAncia exata",
      "ro": "echivalentul exact",
      "ru": "\u0442\u043E\u0447\u043D\u043E\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
      "sl": "natan\u010Dno ujemanje",
      "sq": "p\xEBrputhje e p\xEBrpikt\xEB",
      "sr": "\u0442\u0430\u0447\u043D\u043E \u043F\u043E\u0434\u0443\u0434\u0430\u0440\u0430\u045A\u0435",
      "sv": "exakt tr\xE4ff",
      "tr": "tam e\u015Fle\u015Fme",
      "uk": "\u0442\u043E\u0447\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C",
      "ur": "\u0628\u0627\u0644\u06A9\u0644 \u062F\u0631\u0633\u062A \u062C\u0648\u0691",
      "zh": "\u7CBE\u78BA\u5339\u914D",
      "zh-cn": "\u7CBE\u786E\u5339\u914D",
      "zh-hans": "\u7CBE\u786E\u5339\u914D",
      "zh-hant": "\u7CBE\u78BA\u5339\u914D"
    },
    "SHORT": "exact",
    "uri": "http://www.w3.org/2004/02/skos/core#exactMatch"
  },
  {
    "RELEVANCE": "high",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "in etwa gleiche Bedeutung"
      ],
      "en": [
        "same general idea but not fully identical meaning"
      ]
    },
    "notation": [
      "\u2248"
    ],
    "prefLabel": {
      "ar": "\u062A\u0637\u0627\u0628\u0642 \u0642\u0631\u064A\u0628",
      "be-tarask": "\u0431\u043B\u0456\u0437\u043A\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u044C\u0446\u044C",
      "ca": "equival\xE8ncia inexacta",
      "de": "hohe \xDCbereinstimmung",
      "el": "\u03C3\u03C4\u03B5\u03BD\u03AE \u03B1\u03BD\u03C4\u03B9\u03C3\u03C4\u03BF\u03B9\u03C7\u03AF\u03B1",
      "en": "close match",
      "eo": "proksima kongrua\u0135o",
      "es": "equivalencia inexacta",
      "fi": "l\xE4hes vastaava k\xE4site",
      "fr": "quasi-\xE9quivalence",
      "he": "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E7\u05E8\u05D5\u05D1\u05D4",
      "hu": "kv\xE1zi-egyen\xE9rt\xE9k\u0171s\xE9g",
      "it": "corrispondenza parziale",
      "ja": "\u985E\u4F3C\u4E00\u81F4",
      "mk": "\u0431\u043B\u0438\u0441\u043A\u043E \u0441\u043E\u0432\u043F\u0430\u0453\u0430\u045A\u0435",
      "ms": "padanan dekat",
      "ms-arab": "\u06A4\u0627\u062F\u0646\u0646 \u062F\u06A9\u062A",
      "nb": "n\xE6rt samsvar",
      "nl": "nabije match",
      "nn": "n\xE6rt samsvar",
      "pl": "cz\u0119\u015Bciowe dopasowanie",
      "pt": "correspond\xEAncia pr\xF3xima",
      "ru": "\u0431\u043B\u0438\u0437\u043A\u043E\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
      "sl": "visoko ujemanje",
      "sr": "\u0431\u043B\u0438\u0441\u043A\u043E \u043F\u043E\u043A\u043B\u0430\u043F\u0430\u045A\u0435",
      "sv": "n\xE4ra matchning",
      "tr": "yak\u0131n e\u015Fle\u015Fme",
      "zh-hans": "\u9AD8\u5EA6\u5339\u914D"
    },
    "SHORT": "close",
    "uri": "http://www.w3.org/2004/02/skos/core#closeMatch"
  },
  {
    "RELEVANCE": "medium",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "umfassendere Bedeutung"
      ],
      "en": [
        "broader meaning"
      ]
    },
    "notation": [
      ">"
    ],
    "prefLabel": {
      "be-tarask": "\u0448\u044B\u0440\u043E\u043A\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u044C\u0446\u044C",
      "ca": "relaci\xF3 llunyana",
      "cs": "\u0161ir\u0161\xED koncept",
      "de": "allgemeinere Bedeutung",
      "en": "broad match",
      "eo": "malstrikta kongruo",
      "et": "laiem vaste",
      "fi": "vastaava laajempi k\xE4site",
      "he": "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E8\u05D7\u05D1\u05D4",
      "hu": "t\xE1gabb jelent\xE9s",
      "it": "corrispondenza con termine pi\xF9 generico",
      "ja": "\u5E83\u7FA9\u4E00\u81F4",
      "mk": "\u043F\u043E\u0448\u0438\u0440\u043E\u043A\u043E \u0441\u043E\u0432\u043F\u0430\u0453\u0430\u045A\u0435",
      "nb": "bredere samsvar",
      "nl": "brede match",
      "nn": "breitt samsvar",
      "pl": "dopasowanie poj\u0119cia o szerszym znaczeniu",
      "pt-br": "correspond\xEAncia gen\xE9rica",
      "ru": "\u0431\u043E\u043B\u0435\u0435 \u0448\u0438\u0440\u043E\u043A\u043E\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
      "sl": "splo\u0161ni pomen",
      "sr": "\u0443 \u0448\u0438\u0440\u0435\u043C \u0441\u043C\u0438\u0441\u043B\u0443",
      "sv": "bred tr\xE4ff",
      "uk": "\u0448\u0438\u0440\u0448\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C",
      "vi": "\u0111\u1ED1i s\xE1nh r\u1ED9ng",
      "zh-hans": "\u5E7F\u6CDB\u5339\u914D"
    },
    "related": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#narrowMatch"
      }
    ],
    "SHORT": "broad",
    "uri": "http://www.w3.org/2004/02/skos/core#broadMatch"
  },
  {
    "RELEVANCE": "medium",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "en": [
        "more specific meaning"
      ]
    },
    "notation": [
      "<"
    ],
    "prefLabel": {
      "be-tarask": "\u0432\u0443\u0437\u043A\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u044C\u0446\u044C",
      "ca": "relaci\xF3 estreta",
      "de": "spezifischere Bedeutung",
      "en": "narrow match",
      "eo": "strikta kongruo",
      "et": "kitsam vaste",
      "fi": "vastaava suppeampi k\xE4site",
      "he": "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E6\u05E8\u05D4",
      "hu": "sz\u0171kebb jelent\xE9s",
      "it": "corrispondenza con termine pi\xF9 specifico",
      "ja": "\u72ED\u7FA9\u4E00\u81F4",
      "mk": "\u043F\u043E\u0442\u0435\u0441\u043D\u043E \u0441\u043E\u0432\u043F\u0430\u0453\u0430\u045A\u0435",
      "nb": "smalere samsvar",
      "nl": "nauwe match",
      "nn": "snevert samsvar",
      "pl": "dopasowanie poj\u0119cia o w\u0119\u017Cszym znaczeniu",
      "pt-br": "correspond\xEAncia aproximada",
      "ru": "\u0431\u043E\u043B\u0435\u0435 \u0443\u0437\u043A\u043E\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
      "sl": "ozki pomen",
      "sr": "\u0443 \u0443\u0436\u0435\u043C \u0441\u043C\u0438\u0441\u043B\u0443",
      "sv": "smal tr\xE4ff",
      "ur": "\u0646\u06CC\u0631\u0648 \u0645\u06CC\u0686",
      "vi": "\u0111\u1ED1i s\xE1nh h\u1EB9p",
      "zh-hans": "\u6709\u9650\u5339\u914D"
    },
    "related": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#broadMatch"
      }
    ],
    "SHORT": "narrow",
    "uri": "http://www.w3.org/2004/02/skos/core#narrowMatch"
  },
  {
    "RELEVANCE": "low",
    "broader": [
      {
        "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
      }
    ],
    "definition": {
      "de": [
        "assoziative Verkn\xFCpfung unterschiedlicher Bedeutungen"
      ],
      "en": [
        "associative link between meanings"
      ]
    },
    "notation": [
      "~"
    ],
    "prefLabel": {
      "be-tarask": "\u0437\u044C\u0432\u044F\u0437\u0430\u043D\u0430\u044F \u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u0441\u044C\u0446\u044C",
      "ca": "parella relacionada",
      "de": "verwandte Bedeutung",
      "en": "related match",
      "eo": "rilata kongruo",
      "fi": "liittyv\xE4 k\xE4site",
      "fr": "association",
      "he": "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E7\u05E9\u05D5\u05E8\u05D4",
      "hu": "rokon jelent\xE9s",
      "it": "corrispondenza correlata",
      "ja": "\u95A2\u9023\u4E00\u81F4",
      "lv": "saist\u012Bta sakrit\u012Bba",
      "mk": "\u043F\u043E\u0432\u0440\u0437\u0430\u043D\u043E \u0441\u043E\u0432\u043F\u0430\u0453\u0430\u045A\u0435",
      "ms": "padanan berkaitan",
      "ms-arab": "\u06A4\u0627\u062F\u0646\u0646 \u0628\u0631\u06A9\u0627\u0621\u064A\u062A\u0646",
      "nb": "relatert samsvar",
      "nl": "gerelateerde match",
      "pl": "dopasowanie poj\u0119cia o powi\u0105zanym znaczeniu",
      "ru": "\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
      "sl": "povezano ujemanje",
      "tr": "ili\u015Fkili benze\u015Fme",
      "uk": "\u043F\u043E\u0432\u2019\u044F\u0437\u044C",
      "ur": "\u0645\u062A\u0639\u0644\u0642\u06C1 \u0645\u06CC\u0686",
      "vec": "parente\u0142a re\u0142asionada",
      "zh-hans": "\u5173\u8054\u5339\u914D"
    },
    "SHORT": "related",
    "uri": "http://www.w3.org/2004/02/skos/core#relatedMatch"
  },
  {
    "RELEVANCE": "generic",
    "definition": {
      "de": [
        "unbekannter Bedeutungszusammenhang"
      ],
      "en": [
        "unknown type of link between meanings"
      ]
    },
    "notation": [
      "\u2192"
    ],
    "prefLabel": {
      "ar": "\u0646\u0648\u0639 \u0639\u0644\u0627\u0642\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
      "be": "\u0445\u0430\u0440\u0430\u043A\u0442\u044D\u0440\u043D\u0430\u044F \u0430\u0434\u043D\u043E\u0441\u0456\u043D\u0430 \u0430\u0434\u043B\u044E\u0441\u0442\u0440\u0430\u0432\u0430\u043D\u043D\u044F",
      "be-tarask": "\u0445\u0430\u0440\u0430\u043A\u0442\u044D\u0440\u043D\u0430\u044F \u0430\u0434\u043D\u043E\u0441\u0456\u043D\u0430 \u0430\u0434\u043B\u044E\u0441\u0442\u0440\u0430\u0432\u0430\u043D\u044C\u043D\u044F",
      "ca": "relaci\xF3 de mapatge",
      "de": "allgemeine Mapping-Relation",
      "en": "SKOS generic mapping relation",
      "fi": "SKOS-kartoitussuhde",
      "fr": "lien de correspondance SKOS",
      "he": "\u05D9\u05D7\u05E1 \u05DE\u05D9\u05E4\u05D5\u05D9 \u05DB\u05DC\u05DC\u05D9",
      "id": "relasi pemetaan",
      "ja": "SKOS\u4E00\u822C\u30DE\u30C3\u30D4\u30F3\u30B0\u95A2\u4FC2",
      "mk": "\u043F\u0440\u0435\u0441\u043B\u0438\u043A\u0443\u0432\u0430\u0447\u043A\u0438 \u043E\u0434\u043D\u043E\u0441",
      "nb": "SKOS generisk mappingrelasjon",
      "pt-br": "rela\xE7\xE3o gen\xE9rica de mapeamento",
      "sl": "splo\u0161na relacija kartiranja SKOS",
      "sr": "\u0440\u0435\u043B\u0430\u0446\u0438\u0458\u0430 \u043C\u0430\u043F\u0438\u0440\u0430\u045A\u0430",
      "sv": "mappnings relation",
      "zh": "\u6620\u5C04\u95DC\u4FC2",
      "zh-hant": "\u6620\u5C04\u95DC\u4FC2"
    },
    "SHORT": "",
    "uri": "http://www.w3.org/2004/02/skos/core#mappingRelation"
  }
];
export {
  mapping_types_default as default
};
